import axios from "axios";

const admin = JSON.parse(localStorage.getItem("ADMIN"));
if (admin) {
  axios.defaults.headers.common["x-access-token"] = admin.token;
}
axios.defaults.headers.common["platform"] = "AdminWeb";

// Wrapper for AI Past Sessions admin endpoints
export default {
  AiPastSessionsApi(url = `${process.env.REACT_APP_BASE_URL}/api`) {
    return {
      list: (data) =>
        axios.post(`${url}/ai-past-sessions/admin/list`, data ?? {}),

      batches: (data) =>
        axios.post(`${url}/ai-past-sessions/admin/batches`, data ?? {}),

      assignToBatch: (data) =>
        axios.post(`${url}/ai-past-sessions/admin/assign-to-batch`, data),

      manualCreateBatch: (data) => {
        const admin = JSON.parse(localStorage.getItem("ADMIN"));
        return axios.post(
          `${url}/ai-past-sessions/admin/batch/manual-create`,
          data,
          {
            headers: admin?.token
              ? { "x-access-token": admin.token }
              : undefined,
          },
        );
      },

      updateBatch: (id, data) => {
        const admin = JSON.parse(localStorage.getItem("ADMIN"));
        return axios.put(
          `${url}/ai-past-sessions/admin/batch/${id}`,
          data,
          {
            headers: admin?.token
              ? { "x-access-token": admin.token }
              : undefined,
          },
        );
      },

      createOrEdit: (data) => {
        const payload = {
          ...data,
          zoomMeetingLink: data?.zoomMeetingLink,
        };

        return axios.post(
          `${url}/ai-past-sessions/admin/createOrEditAiPastSession`,
          payload,
        );
      },

      delete: (id) =>
        axios.delete(`${url}/ai-past-sessions/admin/delete/${id}`),

      listQueries: (data) =>
        axios.post(`${url}/ai-past-sessions/admin/query/list`, data ?? {}),

      replyQuery: (data) =>
        axios.post(`${url}/ai-past-sessions/admin/query/reply`, data),

      pendingQueryCount: () =>
        axios.get(`${url}/ai-past-sessions/admin/query/pending-count`),

      updateQueryVisibility: (id, data) =>
        axios.put(`${url}/ai-past-sessions/query/${id}/visibility`, data),
    };
  },
};
